export default {

  listeners: [],
  currentValue: null,

  update(newValue) {
    const self = this;
    this.listeners.forEach(function (callback) {
      callback(newValue);
      self.currentValue = newValue;
    });
  },

  addListener(callback) {
    this.listeners.push(callback);
  },

  removeListener(callback) {
    const index = this.listeners.indexOf(callback);

    if (index > -1) {
      this.listeners.splice(index, 1);
    }
  },

  getValue() {
    return this.currentValue;
  }

};
